import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonPostPutFormData } from "../../../redux/reducers/commonApiSlice";
import { update_gym } from "../../../data/ApiEndpoints";
import Loader from "../../ui/Loader";
import { BinIcon, BinIcon1, EditIcon } from "../../../images/icons/icons";

const UrlUpdateForm = ({
  rowData,
  userInfoData,
  callFunction,
  closeModal,
  modName,
}) => {
  const dispatch = useDispatch();

  const { postPutLoadingFormData } = useSelector((state) => state.common);

  const [urlData, setUrlData] = useState({
    url:
      modName === "update_gmb_url"
        ? rowData?.gmb_url || ""
        : rowData?.short_url || "",
  });

  const [isEditing, setIsEditing] = useState(false);



  const onSubmitForm = () => {
    if (!urlData.url && (rowData?.gmb_url || rowData?.short_url)) {
      // If URL is empty but there was a previous URL, we're deleting
      const userData = {
        gym_name: rowData?.gym_name || "",
        name: rowData?.name || "",
        user_id: rowData?.user_id || "",
        address1: rowData?.address1 || "",
        address2: rowData?.address2 || "",
        city: rowData?.city || "",
        state: rowData?.state || "",
        pin: rowData?.pin || "",
        country: rowData?.country || "",
        lat: rowData?.lat || "",
        long: rowData?.long || "",
        description: rowData?.description || "",
        modules: rowData?.modules || [
          "trainer", "member", "benefits", "addon", "events", "gallery",
          "equipments", "offers", "feedbacks", "subscription", "financial_reports",
          "sessions", "trainer_and_member_mapping", "workout_mapping", "diet_mapping"
        ],
        type: rowData?.type || "gym",
        status: rowData?.status || "",
        slug: rowData?.slug || "",
        wtf_share: rowData?.wtf_share || "",
        google_rating: rowData?.google_rating || "",
        lease_agreement: rowData?.lease_agreement || "",
        electricity_bill: rowData?.electricity_bill || "",
        bank_statement: rowData?.bank_statement || "",
        category_id: rowData?.category_id || "",
        device_id: rowData?.device_id || "",
        is_100: rowData?.is_100 || 0,
        plan_type: rowData?.plan_type || "",
        is_partial: rowData?.is_partial || "",
        is_cash: rowData?.is_cash || "",
        is_settlement: rowData?.is_settlement || "",
        is_discount: rowData?.is_discount || "",
        cto: rowData?.cto || "",
        is_minimum: rowData?.is_minimum || "",
        guarantee_value: rowData?.guarantee_value || "",
        poc_name: rowData?.poc_name || "",
        poc_mobile: rowData?.poc_mobile || "",
        is_gst: rowData?.is_gst || "",
        gst_number: rowData?.gst_number || "",
        is_gst_inclusive: rowData?.is_gst_inclusive || "",
        account_number: rowData?.account_number || "",
        ifsc_code: rowData?.ifsc_code || "",
        bank_name: rowData?.bank_name || "",
        // URL fields - only the one we're deleting gets empty
        gmb_url: modName === "update_gmb_url" ? "" : rowData?.gmb_url || "",
        short_url:
          modName === "update_short_url" ? "" : rowData?.short_url || "",
      };

      const handleConfirmSubmit = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(
        handleConfirmSubmit,
        `Confirm to delete the ${
          modName === "update_gmb_url" ? "GMB URL" : "Short URL"
        }!`,
        "Delete URL",
        "Delete"
      );
    } else {
      // Adding or updating URL
      const userData = {
        gym_name: rowData?.gym_name || "",
        name: rowData?.name || "",
        user_id: rowData?.user_id || "",
        address1: rowData?.address1 || "",
        address2: rowData?.address2 || "",
        city: rowData?.city || "",
        state: rowData?.state || "",
        pin: rowData?.pin || "",
        country: rowData?.country || "",
        lat: rowData?.lat || "",
        long: rowData?.long || "",
        description: rowData?.description || "",
        modules: rowData?.modules || [
          "trainer", "member", "benefits", "addon", "events", "gallery",
          "equipments", "offers", "feedbacks", "subscription", "financial_reports",
          "sessions", "trainer_and_member_mapping", "workout_mapping", "diet_mapping"
        ],
        type: rowData?.type || "gym",
        status: rowData?.status || "",
        slug: rowData?.slug || "",
        wtf_share: rowData?.wtf_share || "",
        google_rating: rowData?.google_rating || "",
        lease_agreement: rowData?.lease_agreement || "",
        electricity_bill: rowData?.electricity_bill || "",
        bank_statement: rowData?.bank_statement || "",
        category_id: rowData?.category_id || "",
        device_id: rowData?.device_id || "",
        is_100: rowData?.is_100 || 0,
        plan_type: rowData?.plan_type || "",
        is_partial: rowData?.is_partial || "",
        is_cash: rowData?.is_cash || "",
        is_settlement: rowData?.is_settlement || "",
        is_discount: rowData?.is_discount || "",
        cto: rowData?.cto || "",
        is_minimum: rowData?.is_minimum || "",
        guarantee_value: rowData?.guarantee_value || "",
        poc_name: rowData?.poc_name || "",
        poc_mobile: rowData?.poc_mobile || "",
        is_gst: rowData?.is_gst || "",
        gst_number: rowData?.gst_number || "",
        is_gst_inclusive: rowData?.is_gst_inclusive || "",
        account_number: rowData?.account_number || "",
        ifsc_code: rowData?.ifsc_code || "",
        bank_name: rowData?.bank_name || "",
        // URL fields - update the one we're editing
        gmb_url:
          modName === "update_gmb_url" ? urlData.url : rowData?.gmb_url || "",
        short_url:
          modName === "update_short_url"
            ? urlData.url
            : rowData?.short_url || "",
      };

      const handleConfirmSubmit = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(
        handleConfirmSubmit,
        `Confirm to ${urlData.url ? "save" : "update"} the ${
          modName === "update_gmb_url" ? "GMB URL" : "Short URL"
        }!`,
        "Save URL",
        "Save"
      );
    }
  };

  const handleAdd = async (userData) => {
    const method = "PUT";
    const endpoint = update_gym; 
    const token = userInfoData?.token;

    // Convert userData to FormData like the main gym form does
    const formData = new FormData();
    for (const key in userData) {
      if (userData.hasOwnProperty(key)) {
        formData.append(key, userData[key]);
      }
    }
    
    // Add uid for edit operations
    formData.append("uid", rowData?.uid || rowData?.gym_id);

    try {
      const result = await dispatch(
        commonPostPutFormData({ method, endpoint, requestBody: formData, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setIsEditing(false);
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making PUT request:", error);
      
    }
  };

  const currentUrl =
    modName === "update_gmb_url" ? rowData?.gmb_url : rowData?.short_url;

  return (
    <form className="formContainer">
      <div className="formInputBox">
        <label htmlFor="urlInput" className="formInputLabel">
          {modName === "update_gmb_url" ? "GMB URL" : "Short URL"}
        </label>

        <div style={{ display: "flex", gap: "10px", alignItems: "flex-start", width:"100%" }}>
          <input
            type="url"
            id="urlInput"
            className="commonInput"
            placeholder={`Enter ${
              modName === "update_gmb_url" ? "GMB" : "Short"
            } URL`}
            value={urlData.url}
            onChange={(e) => setUrlData({ url: e.target.value })}
            readOnly={currentUrl && !isEditing}
            style={{
              flex: 1,
              width:"100%",
              padding: "10px",
              border: "1px solid #ddd",
              borderRadius: "4px",
              fontSize: "14px",
              backgroundColor: (currentUrl && !isEditing) ? "#f8f9fa" : "#fff",
              cursor: (currentUrl && !isEditing) ? "default" : "text",
            }}
          />

          {currentUrl && (
            <div style={{ display: "flex", gap: "20px" }}>
              {isEditing ? (
                <button
                  type="button"
                  onClick={() => {
                    setUrlData({ url: currentUrl });
                    setIsEditing(false);
                  }}
                  
                  style={{
                    backgroundColor: "#e71815",
                    padding: "9px 16px",
                    color: "white",
                    fontSize: "16px",
                    fontWeight:"500",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    onClick={() => {
                      setUrlData({ url: currentUrl });
                      setIsEditing(true);
                    }}
                    style={{
                      padding:"10px 16px",
                      color: "black",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "12px",
                      whiteSpace: "nowrap",
                    }}
                    title="Edit URL"
                  >
                    <EditIcon />
                  </button>
                </>
              )}
            </div>
          )}
        </div>

      </div>

      <div
        className="formButtons"
        style={{ justifyContent: "flex-end", marginTop: "20px" }}
      >
        <Button
          type="button"
          className="saveBtn"
          variant="danger"
          onClick={onSubmitForm}
        >
          {postPutLoadingFormData ? <Loader /> : "Save"}
        </Button>
      </div>
    </form>
  );
};

export default UrlUpdateForm;
